export default {
    en: {
        FOOTER_TEXT: {
            VACR: "© {thisYear}",
            USCR: "© {thisYear} - Powered by"
        },
        FOOTER_LINK_LABEL: {
            VACR: "Virginia Cyber Range Homepage",
            USCR: "U.S. Cyber Range Homepage"
        }
    }
};
